/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import {
  type FieldContentsData,
  type IntegrationContent,
} from '../../shared-types';
import { FlexRow } from '@lib/canvasx/components/FlexRow';
import { Image } from '@lib/canvasx/components/Image';
import { canvasCssValue } from '@lib/canvasx/util';

export const IntegrationField: CanvaSXFC<{
  integration: IntegrationContent;
  contents: FieldContentsData;
  fieldId: RecordId;
}> = function ({ integration, fieldId }) {
  const { name, url, icon } = integration;

  const key = `integration:${fieldId}`;
  const { object } = CanvaSX.context;

  let textColorVar = '--theme-secondary-text';
  let textColorFallback = '#666666';
  if (object?.hoveredKey === key) {
    textColorVar = '--theme-link-text';
    textColorFallback = '#0073cf';
  }

  return (
    <FlexRow
      key={key}
      gap={3}
      verticalAlignment='center'
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
    >
      {icon && <Image key={`${key}:image`} src={icon} width={11} height={11} />}

      <Text
        size={11}
        color={canvasCssValue(textColorVar, textColorFallback)}
        lineHeight={1.4}
      >
        {name}
      </Text>
    </FlexRow>
  );
};
